/**
 * @flow
 * @relayHash 20e6b62c122648cb843c6b8be3f713a7
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type SharedModifyPortfolioItemsMutationVariables = {|
  input: {
    action: "ADD" | "EDIT" | "REMOVE" | "REORDER";
    endPortfolioItemId?: ?string;
    itemsIds?: ?$ReadOnlyArray<?string>;
    note?: ?string;
    portfolioItemsIds?: ?$ReadOnlyArray<?string>;
    portfolioId?: ?string;
    portfolioType?: ?"HEART" | "CART";
    startPortfolioItemId?: ?string;
    targetPortfolioItemId?: ?string;
    userId: string;
    clientMutationId?: ?string;
  };
|};
export type SharedModifyPortfolioItemsMutationResponse = {|
  +modifyPortfolioItems: ?{|
    +removedItemIds: ?$ReadOnlyArray<?string>;
  |};
|};
*/


const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "ModifyPortfolioItemsInput!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SharedModifyPortfolioItemsMutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "ModifyPortfolioItemsInput!"
          }
        ],
        "concreteType": "ModifyPortfolioItemsPayload",
        "name": "modifyPortfolioItems",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "removedItemIds",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations"
  },
  "id": "app-buyer-mobile/173.0.0-2018-06-22T14:05:01.024Z/SharedModifyPortfolioItemsMutation",
  "kind": "Batch",
  "metadata": {},
  "name": "SharedModifyPortfolioItemsMutation",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "ModifyPortfolioItemsInput!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "SharedModifyPortfolioItemsMutation",
    "operation": "mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "ModifyPortfolioItemsInput!"
          }
        ],
        "concreteType": "ModifyPortfolioItemsPayload",
        "name": "modifyPortfolioItems",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "removedItemIds",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": null
};

module.exports = batch;
